import React, { FC, useId } from 'react';
import { Button, Dropdown, Heading, Paragraph } from '@digdir/designsystemet-react';
import { ChevronDownIcon } from '@navikt/aksel-icons';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { MenuDropdownButton } from '../../tilstand/styledComponents';
import { Tiltak } from '../../../../../types/registration/tiltak';
import { useDeleteTiltak } from '../hooks/useDeleteTiltak';

import { StyledTiltakItemCard } from './styledComponents';

interface TiltakItemCardProps {
  tiltak: Tiltak;
  isDone: boolean;
}

export const TiltakItemCard: FC<TiltakItemCardProps> = ({ tiltak, isDone }) => {
  const { navnBokmal, beskrivelseNynorsk, energiplanId, tiltakId } = tiltak;
  const dropdownId = useId();
  const { t } = useTranslation();

  const { deleteTiltak, isLoading } = useDeleteTiltak(energiplanId);

  if (!tiltakId) {
    return null;
  }

  return (
    <StyledTiltakItemCard>
      <div>
        <Heading data-size="xs" level={4}>
          {navnBokmal}
        </Heading>
        <Paragraph data-size="xs">{beskrivelseNynorsk}</Paragraph>
      </div>
      {!isDone && (
        <>
          <Button variant="secondary" popovertarget={dropdownId} loading={isLoading}>
            {t('screens.energiplan.components.tiltakItemCard.optionsButton')}
            <ChevronDownIcon aria-hidden />
          </Button>
          <Dropdown id={dropdownId}>
            <Dropdown.List>
              <Dropdown.Item>
                <MenuDropdownButton asChild>
                  <Link to={`tiltak/${tiltakId}`}>{t('screens.energiplan.components.tiltakItemCard.editButton')}</Link>
                </MenuDropdownButton>
                <MenuDropdownButton onClick={() => deleteTiltak(tiltakId)} disabled={isLoading}>
                  {t('screens.energiplan.components.tiltakItemCard.deleteButton')}
                </MenuDropdownButton>
              </Dropdown.Item>
            </Dropdown.List>
          </Dropdown>
        </>
      )}
    </StyledTiltakItemCard>
  );
};
